import React, { useState, useEffect } from 'react'
import { createStyles } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import {GET_ONE, withDataProvider} from 'react-admin'
import Parser from "html-react-parser";
import formatHtml from "../../utils/formatHtml";
import { Accordion, AccordionItem } from 'react-light-accordion';

import 'react-light-accordion/demo/css/index.css';
import './Accordion.css'
import SimpleTestItem from "./testTypes/SimpleTestItem";
import MultipleTestItem from "./testTypes/MultipleTestItem";
import AccordanceTestItem from "./testTypes/AccordanceTestItem";
import CompositeTestItem from "./testTypes/CompositeTestItem";
import SequenceTestItem from "./testTypes/SequenceTestItem";
import CalculateTestItem from "./testTypes/CalculateTestItem";


const styles = createStyles({
  formGroup: {
    marginBottom: '15px'
  },
  question: {
    padding: '0px 15px 15px',
    marginBottom: '15px'
  },
  panelHeader: {
    padding: '15px',
    backgroundColor: '#eee',
    marginBottom: '15px'
  },
  panelAnswer: {
    padding: '15px',
    backgroundColor: '#b71c1c',
    color: '#fff',
    marginBottom: '15px'
  },
  panelExperts: {
    padding: '15px',
    backgroundColor: '#ca7e18',
    color: '#fff',
    marginBottom: '15px'
  },
  accordionItem: {
    padding: '0px 15px 15px',
  },
  link: {
    color: 'blue',
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer'
    }
  },
  textHide: {
    height: '4em',
    paddingTop: '15px',
    overflow: 'hidden'
  },
  textTask: {
    height: '0px',
    paddingTop: '15px',
    overflow: 'hidden'
  },
  pLeft: {
    paddingLeft: '15px'
  },
  tableBordered: {
    width: '100%',

    '& tr th': {
      padding: '7px 12px',
      border: '1px solid #ddd',
      backgroundColor: '#eee',
      textAlign: "left"
    },

    '& tr td': {
      border: '1px solid #ddd',
      padding: '3px 12px'
    },

    '& tr:last-child td': {
      border: '1px solid #ddd',
      padding: '7px 12px'
    },

    '& tr td input': {
      width: '100%',
      padding: '7px 0',
      border: 'none',
      backgroundColor: '#fafafa'
    },
    '& tr td textarea': {
      width: '100%',
      padding: '7px 0',
      marginTop: '5px',
      border: 'none',
      backgroundColor: '#fafafa'
    }
  },
  mark: {
    maxWidth: 300
  },
  diff: {
    backgroundColor: '#f0fff6'
  },
  expertItem: {
    marginBottom: 25
  },
  expertName: {
    marginTop: 0,
    marginBottom: 5
  }
})

const ExamTicketPreviewModal = withStyles(styles)(({showModal, setShowModal, workId, setWorkId, classes, dataProvider}: any) => {
  const [workData, setWorkData] = useState<any>(null)

  /**
   * Закрывает модальное окно.
   */
  const closeModal = () => {
    setShowModal(false)
  }

  /**
   * Показываем/скрываем текст задания
   * @param event
   */
  const toggleTask = (event) => {
    const labelToggle = event.target.getAttribute('data-label')
    const label = event.target.innerText
    let node = event.target.parentNode.parentNode.children[0];

    if (label === 'Скрыть') {
      node.style = 'height: 0px'
    } else {
      node.style = 'height: inherit'
    }

    event.target.innerText = labelToggle
    event.target.setAttribute('data-label', label)
  }

  /**
   * Показываем/скрываем текст вопроса
   * @param event
   */
  const toggleQuestion = (event) => {
    const labelToggle = event.target.getAttribute('data-label')
    const label = event.target.innerText
    let node = event.target.parentNode.parentNode.children[0];

    if (label === 'Скрыть') {
      node.style = 'height: 3.5em'
    } else {
      node.style = 'height: inherit'
    }

    event.target.innerText = labelToggle
    event.target.setAttribute('data-label', label)
  }

  /**
   * Показываем/скрываем оценки экспертов.
   * @param event
   */
  const toggleExpertBalls = (event) => {
    const labelToggle = event.target.getAttribute('data-label')
    const label = event.target.innerText
    let node = event.target.parentNode.parentNode.children[0];

    if (label === 'Скрыть') {
      node.style = 'height: 0px'
    } else {
      node.style = 'height: inherit'
    }

    event.target.innerText = labelToggle
    event.target.setAttribute('data-label', label)
  }

  const fetchWork = async () => {
    try {
      const response = await dataProvider(GET_ONE, 'exam-tickets', {
        id: workId,
        url: 'exam-tickets'
      })
      setWorkData(response.data)
    } catch (e) {
      throw new Error(e.message)
    }
  }

  useEffect(() => {
    if (workId) {
      fetchWork()
    }
    return () => {
      setWorkData(null)
    }
  }, [workId])

  if (!workData) return null

  const isDiff = (segmentNumber, questionNumber, row) => {
    if (workData.segments[segmentNumber].ballsResult.length < 2) {
      return false
    }

    if (workData.segments[segmentNumber].ballsResult[0][questionNumber] === undefined) {
      return false
    }

    if (workData.segments[segmentNumber].ballsResult[1][questionNumber] === undefined) {
      return false
    }

    let item1, item2

    try {
      item1 = workData.segments[segmentNumber].ballsResult[0][questionNumber].items[row].balls
      item2 = workData.segments[segmentNumber].ballsResult[1][questionNumber].items[row].balls
    } catch (e) {
      return false
    }

    return item1 != item2
  }

  return (
    <Dialog
      fullWidth={true}
      maxWidth={false}
      open={showModal}
      onClose={closeModal}
    >
      <DialogTitle>Экзаменационная работа {workData.exam.level.id === 3 ? '3-его' : (workData.exam.level.id + '-ого')} этапа №{workData.ticket.number}</DialogTitle>
      <DialogContent>
        <Accordion atomic={true}>
          {workData && workData.segments.map((segment, index) => {
            if (segment.case) {
              return <AccordionItem title={'Задание ' + (index + 1)}>
                <h2 className={classes.pLeft}>Сегмент {segment.id}</h2>
                <div className={classes.accordionItem}>
                  <div className={classes.textTask}>
                    <div className={classes.question}>
                      {Parser(formatHtml(segment.case.task.content))}
                    </div>
                  </div>
                  <div className={classes.question}>
                    <span className={classes.link} onClick={toggleTask} data-label="Скрыть">Показать задание</span>
                  </div>
                  {(segment.case.questions.map((question, number) => {
                    return (
                      <div className={classes.formGroup}>
                        <div>
                          <div className={classes.textHide}>
                            <div className={classes.panelHeader}>Вопрос {(number + 1)}</div>
                            <div className={classes.question}>
                              {Parser(formatHtml(question.content))}
                            </div>
                          </div>
                          <div className={classes.question}>
                            <span className={classes.link} onClick={toggleQuestion} data-label="Скрыть">Показать вопрос</span>
                          </div>
                        </div>
                        <div className={classes.panelAnswer}>Ответ претендента</div>
                        <div className={classes.question}>
                          {question.applicantAnswer && (
                            <>
                              {Parser(formatHtml(question.applicantAnswer.answer !== null ? question.applicantAnswer.answer : ''))}
                              {question.applicantAnswer.files.length > 0 && (
                                <div className={classes.formGroup}>
                                  <br />
                                  Файлы:&nbsp;
                                  {question.applicantAnswer.files.map((file) => (
                                      <a href={file.link} target="_blank">{ file.name }</a>
                                  ))}
                                </div>
                              )}
                            </>
                          )}
                        </div>
                        <div className={classes.panelExperts}>Оценки экспертов</div>
                        <div className={classes.question}>
                          <div className={classes.textTask}>
                            <div className={classes.expertItem}>
                              <table className={classes.tableBordered}>
                                <thead>
                                  <tr>
                                    <th>№ задания</th>
                                    <th>Маркировочная позиция</th>
                                    <th>Макс. балл</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    {segment.ballsResult.map((expertInfo, expertIndex) => (
                                        <th style={{width: 100}}>
                                          {workData.experts[expertIndex].surname} {workData.experts[expertIndex].name} {workData.experts[expertIndex].middleName}
                                        </th>
                                    ))}
                                  </tr>
                                </thead>
                                {segment.case.questions[number].ballsInfo.map((infoItem, infoItemIndex) => (
                                    <tr>
                                      <td>{ infoItem.number }</td>
                                      <td className={classes.mark}>{ infoItem.mark }</td>
                                      <td>{ infoItem.maxBalls }</td>
                                      <td>{ infoItem.correctValues }</td>
                                      <td>{ infoItem.solution }</td>
                                      <td>{ infoItem.additionText1 }</td>
                                      <td>{ infoItem.additionText2 }</td>
                                      <td>{ infoItem.additionText3 }</td>
                                      <td>{ infoItem.additionText4 }</td>
                                      {segment.ballsResult.map((expertInfo) => (
                                          <td className={isDiff(index, number, infoItemIndex) ? classes.diff : ''}>
                                            {expertInfo[number] && expertInfo[number].items[infoItemIndex] && expertInfo[number].items[infoItemIndex].balls}
                                          </td>
                                      ))}
                                    </tr>
                                ))}
                                <tr>
                                  <td colSpan={9}>Итого</td>
                                  {segment.ballsResult.map((expertInfo) => (
                                      <td>
                                        <b>
                                          {expertInfo[number] ? expertInfo[number].total : ''}
                                        </b>
                                      </td>
                                  ))}
                                </tr>
                              </table>
                            </div>
                          </div>
                          <div className={classes.question}>
                            <span className={classes.link} onClick={toggleExpertBalls} data-label="Скрыть">Показать оценки</span>
                          </div>
                        </div>
                        <hr />
                      </div>
                    )
                  }))}
                </div>
              </AccordionItem>
            }
            if (segment.test) {
              return <AccordionItem title={'Вопрос ' + (index + 1)}>
                <div className={classes.accordionItem}>
                  <h2>Сегмент {segment.id}</h2>
                  {
                    {
                      1 : <SimpleTestItem record={segment} />,
                      2 : <MultipleTestItem record={segment} />,
                      3 : <AccordanceTestItem record={segment} />,
                      4 : <CompositeTestItem record={segment} />,
                      5 : <SequenceTestItem record={segment} />,
                      6 : <CalculateTestItem record={segment} />
                    }[segment.test.typeId]
                  }
                  <div className={classes.textTask}>
                    <div className={classes.question}>
                      {Parser(formatHtml(segment.test.content).replace(/(<([^>]+)>)/gi, ""))}
                    </div>
                  </div>
                </div>
              </AccordionItem>
            }
          })}
        </Accordion>
      </DialogContent>
    </Dialog>
  )
})

export default withDataProvider(ExamTicketPreviewModal)